import React, { useState } from 'react';
import { FadeIn } from './ui/FadeIn';
import { ChevronDown } from 'lucide-react';
interface FAQItemProps {
  question: string;
  answer: React.ReactNode;
  isOpen: boolean;
  onClick: () => void;
}
function FAQItem({
  question,
  answer,
  isOpen,
  onClick
}: FAQItemProps) {
  return <div className="border border-slate-700/50 bg-slate-800/30 rounded-2xl overflow-hidden transition-colors hover:bg-slate-800/50" data-id="element-13">
      <button className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" onClick={onClick} data-id="element-14">
        <span className="text-lg font-bold text-white pr-4" data-id="element-15">{question}</span>
        <ChevronDown className={`w-5 h-5 text-slate-400 shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-16" />
      </button>
      <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-48 pb-5 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-17">
        <p className="text-slate-300 leading-relaxed" data-id="element-18">{answer}</p>
      </div>
    </div>;
}
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    q: '¿Es un libro largo?',
    a: 'No. Son 20 páginas de acción pura. Lo leés en 15 minutos y lo aplicás esa misma noche. Está diseñado para gente que no tiene tiempo ni energía para leer teoría.'
  }, {
    q: '¿Tengo que comprar suplementos caros?',
    a: 'No. Los suplementos son opcionales y te recomendamos cosas naturales (como el magnesio) que conseguís en cualquier esquina de Argentina por poco dinero.'
  }, {
    q: '¿Sirve si sufro de ansiedad hace años?',
    a: "Sí. Porque no trabajamos con psicología compleja, sino con tu sistema nervioso biológico que es igual para todos. Es un 'hack' físico, no mental."
  }];
  return <section className="py-24 bg-[#0f172a] relative border-t border-slate-800/50" data-id="element-19">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-20">
        <FadeIn data-id="element-21">
          <div className="text-center mb-12" data-id="element-22">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-23">
              Preguntas Frecuentes
            </h2>
            <p className="text-slate-400" data-id="element-24">Todo claro, sin letra chica.</p>
          </div>
        </FadeIn>

        <div className="space-y-4" data-id="element-25">
          {faqs.map((faq, index) => <FadeIn key={index} delay={index * 100} data-id="element-26">
              <FAQItem question={faq.q} answer={faq.a} isOpen={openIndex === index} onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-27" />
            </FadeIn>)}
        </div>
      </div>
    </section>;
}